import { render, staticRenderFns } from "./m-feedback-dialog.vue?vue&type=template&id=2069a380&scoped=true&"
import script from "./m-feedback-dialog.vue?vue&type=script&lang=js&"
export * from "./m-feedback-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-feedback-dialog.vue?vue&type=style&index=0&id=2069a380&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069a380",
  null
  
)

export default component.exports